import * as _ from 'lodash';

export enum PlatformType {
  Other,
  Shopify,
  Bigcommerce,
  Woocommerce,
  Magento,
  Magento2,
  Volusion2,
  Volusion,
  Prestashop,
  Opencart,
  SalesforceMarketingCloud,
  Hybris
}

const supportedPlatforms = [
  PlatformType.Shopify,
  PlatformType.Bigcommerce,
  PlatformType.Woocommerce,
  PlatformType.Magento,
  PlatformType.Magento2
];

export const getAccountPlatform = (platform: string): PlatformType => {
  let platformKey = _.upperFirst(_.camelCase(platform));
  return PlatformType[platformKey] ? PlatformType[platformKey] : PlatformType.Other;
};

export const isSupportedPlatform = (platform) => {
  return (supportedPlatforms.indexOf(platform) > -1);
};
